// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(options?: { [key: string]: any }) {
  return request<{
    data: any;
  }>('/profile', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function currentUserPerms(options?: { [key: string]: any }) {
  return request<{
    data: any;
  }>(`/admin/rbac/users/${options?.userId}/permissions`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function getRbacOptions(options?: { [key: string]: any }) {
  return request<{
    data: { roles: any[]; permissions: any[] };
  }>('/admin/rbac/options', {
    method: 'GET',
    ...(options || {}),
  }).then(res => ({data:res}));
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/login/outLogin', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 登录接口 POST /api/login/account */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.LoginResult>('/api/login/account', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}

export async function createAdminUser(body: {
  name: string;
  email: string;
  phoneNo: string;
  password?: string;
  company?: string;
  zone?: string;
  roleSlugs?: string[];
  permissionKeys?: string[];
  userType?: string;
}, options?: { [key: string]: any }) {
  return request<{
    data: any;
  }>('/admin/users', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function getAdminUser(userId: string, options?: { [key: string]: any }) {
  return request<{
    data: any;
  }>(`/admin/users/${userId}`, {
    method: 'GET',
    ...(options || {}),
  }).then(u => ({ data: u }));
}

export async function updateAdminUser(userId: string, body: {
  name?: string;
  email?: string;
  phoneNo?: string;
  company?: string;
  zone?: string;
  roleSlugs?: string[];
  permissionKeys?: string[];
  status?: string;
}, options?: { [key: string]: any }) {
  return request<{
    data: any;
  }>(`/admin/users/${userId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function getDashboardCards(options?: { [key: string]: any }) {
  console.log(options)
  return request<{
    data: {
      totalDistributors: number;
      totalRetailers: number;
      qrScansMonth: number;
      totalOrders: number;
      changes: {
        distributors: number;
        retailers: number;
        scans: number;
        orders: number;
      };
    };
  }>('/admin/analytics/dashboard/cards', {
    method: 'GET',
    ...(options || {}),
    params: {
      ...options,
    }
  });
}

export async function getDashboardOrderStatus(options?: { [key: string]: any }) {
  return request<{
    data: {
      pending: number;
      fulfilled: number;
      processing: number;
    };
  }>('/admin/analytics/dashboard/order-status', {
    method: 'GET',
    ...(options || {}),
    params: {
      ...options,
    }
  });
}

export async function getDashboardStockMovement(options?: { [key: string]: any }) {
  return request<{
    data: Array<{
      month: string;
      stockIn: number;
      stockOut: number;
    }>;
  }>('/admin/analytics/stock/movement', {
    method: 'GET',
    ...(options || {}),
    params: {
      months: 6,
      ...options?.params,
    }
  });
}

export async function getDashboardDailyScans(options?: { [key: string]: any }) {
  return request<{
    data: Array<{
      bucket: string;
      users: number;
    }>;
  }>('/admin/analytics/dashboard/daily-scans', {
    method: 'GET',
    params: {
      ...options?.params,
    },
    ...(options || {}),
  });
}

export async function getDashboardFunnel(options?: { [key: string]: any }) {
  return request<{
    data: {
      firstScanUsers: number;
      repeatScanUsers: number;
      rewardClaimedUsers: number;
      marketingPercent: number;
    };
  }>('/admin/analytics/funnel', {
    method: 'GET',
    ...(options || {}),
    params: {
      ...options,
    }
  });
}

export async function updateUserProfile(userId: string, body: {
  name?: string;
  email?: string;
  phoneNo?: string;
  countryCode?: string;
  locale?: string;
}, options?: { [key: string]: any }) {
  return request<{
    data: any;
  }>(`/users/${userId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
